import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { DimensionType } from '../../../types/content';
import * as S from './styles';

/* eslint-disable-next-line */
type PageSectionProps = {
  alt: string;
  imageDescription: string;
  imageDimensions: DimensionType;
  src: string;
};

export function PageSection(props: PageSectionProps) {
  const { alt, imageDescription, imageDimensions, src } = props;
  const { height, width } = imageDimensions;

  return (
    <div style={{ maxWidth: width }}>
      <div style={{ maxHeight: height }}>
        <Image
          alt={alt}
          blurDataURL="/icons/blur-placeholder.png"
          layout="responsive"
          placeholder="blur"
          src={src}
          {...imageDimensions}
        />
      </div>
      <S.MarkdownContainer>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {imageDescription}
        </ReactMarkdown>
      </S.MarkdownContainer>
    </div>
  );
}

export default PageSection;
